import React from "react";
import {
  Edit,
  SimpleForm,
  TextInput,
  ImageField,
  LongTextInput,
  translate,
  ReferenceInput,
  SelectInput
} from "react-admin/lib";

const MessageTitle = ({ translate, record }) => {
  return (
    <span>
      {`${translate("message.message")}`} {record ? `"${record.title}"` : ""}
    </span>
  );
};

const Title = translate(MessageTitle);

export const MessageEdit = props => (
  <Edit title={<Title />} {...props}>
    <SimpleForm>
      <TextInput disabled source="title" />
      <LongTextInput disabled source="message" />
      <ImageField source="image.url" title="Image" />
      <ReferenceInput disabled={true}
        source="user"
        reference="user"
        label="ส่งไปยัง">
        <SelectInput optionText="email" />
      </ReferenceInput>
    </SimpleForm>
  </Edit>
);



// WEBPACK FOOTER //
// ./src/components/message/MessageEdit.js